/* eslint-disable no-param-reassign */
/* eslint-disable consistent-return */
import { produce } from 'immer';

import { convertResourceToMacro } from '../helpers';

import { actionTypes } from './actionTypes';

export const InitialState = {
  deleteModalOpen: false,
  drawerOpen: false,
  drawerTitle: null,
  isLoading: true,
  isLoadingRole: true,
  roleList: [],
  role: null,
  tabsMacros: [],
  initialPermissions: [],
  editPermissions: [],
  roleRequestBody: {
    name: '',
    permissions: [],
  },
  customPermissions: [],
  roleNameError: '',
};

export const rolesPermissions = produce((state = InitialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_DRAWER:
      state.drawerOpen = !state.drawerOpen;
      /**
       * reset creteRole, editPermissions, roleNameError
       * state.roleRequestBody.name and roleRequestBody.permissions
       * as well as isLoadingRole when drawer is closed
       */
      if (state.drawerOpen === false) {
        state.drawerTitle = null;
        state.roleRequestBody.name = '';
        state.roleRequestBody.permissions = [];
        state.isLoadingRole = true;
        state.roleNameError = '';
        state.editPermissions = [];
      }

      return state;
    case actionTypes.SET_DRAWER_TITLE:
      state.drawerTitle = action.drawerTitle;

      return state;
    case actionTypes.SET_ROLE:
      state.role = action.role;

      return state;
    case actionTypes.SET_ROLE_LIST:
      state.roleList = action.roleList;

      return state;
    case actionTypes.SET_IS_LOADING:
      state.isLoading = action.isLoading;

      return state;
    case actionTypes.SET_IS_LOADING_ROLE:
      state.isLoadingRole = action.isLoadingRole;

      return state;
    case actionTypes.OPTIMISTICALLY_UPDATE_ROLE_LIST: {
      const roleFound = state.roleList.find((r) => r.id === action.role.id);

      if (roleFound) {
        roleFound.name = action.role.name;

        return state;
      }

      const roleList = [...state.roleList, action.role];

      state.roleList = roleList;

      return state;
    }
    case actionTypes.OPTIMISTICALLY_DELETE_ROLE: {
      state.roleList = state.roleList.filter((r) => {
        return r.id !== action.role.id;
      });

      return state;
    }
    case actionTypes.SET_TABS_MACROS:
      // find communication macro
      for (const tab of action.tabsMacros) {
        const found = tab.macros.find(
          (macro) => macro.id === '9ffc9ed7-1f60-4476-9fac-7a1b767ba1ad',
        );

        // reorder communication macro permissions
        if (found) {
          found.toggles = found.toggles.reduce((init, ele) => {
            const [key] = Object.keys(ele);

            if (key === 'Manage Voice') {
              return [ele, ...init];
            }

            return [...init, ele];
          }, []);
        }
      }
      state.tabsMacros = action.tabsMacros;

      return state;
    case actionTypes.SET_EDIT_PERMISSIONS: {
      state.editPermissions = action.macroSettings;

      return state;
    }
    case actionTypes.SET_INITIAL_PERMISSIONS: {
      state.initialPermissions = action.initialPermissions;

      return state;
    }
    case actionTypes.UPDATE_EDIT_PERMISSIONS: {
      action.roles.forEach((role) => {
        // find the tab the role is in
        for (const tab of state.editPermissions) {
          const macro = tab.macros.find((m) => m.id === role.resource_id);

          if (macro) {
            if (macro.type === 'crud') macro.toggles = role.value;
            if (macro.type === 'toggle') {
              const roleToggles = role.value.map((t) => {
                const [toggle] = Object.keys(t);

                return toggle;
              });
              const macroToggles = [];

              macro.toggles.forEach((t) => {
                const [toggle] = Object.keys(t);

                const index = roleToggles.findIndex((roleToggle) => {
                  return roleToggle === toggle;
                });

                if (index >= 0) {
                  macroToggles.push(role.value[index]);
                } else {
                  macroToggles.push({ [toggle]: false });
                }
              });
              macro.toggles = macroToggles;
            }
            macro.parent = role.parent;
            break; // if role is found start over
          }
        }
      });

      return state;
    }
    case actionTypes.SET_CUSTOM_PERMISSIONS:
      state.customPermissions = action.customPermissions
        .map((record) => convertResourceToMacro(record))
        .sort((a, b) =>
          a.name.trim().toLowerCase() > b.name.trim().toLowerCase() ? 1 : -1,
        );

      return state;
    case actionTypes.SET_ROLE_REQUEST_BODY: {
      state.roleRequestBody.permissions = action.permissions;

      return state;
    }
    case actionTypes.UPDATE_ROLE_REQUEST_BODY: {
      const { permission } = action;
      const { roleRequestBody } = state;

      // TODO: look into using a set to make this cleaner
      const found = roleRequestBody.permissions.find(
        (p) => p.resource_id === permission.resource_id,
      );

      if (found) {
        found.value = permission.value;
      } else {
        roleRequestBody.permissions.push(permission);
      }

      return state;
    }
    case actionTypes.UPDATE_ROLE_REQUEST_BODY_NAME: {
      const { name } = action;

      state.roleRequestBody = { ...state.roleRequestBody, name };

      return state;
    }
    case actionTypes.SET_ROLE_NAME_ERROR: {
      state.roleNameError = action.error;

      return state;
    }
    case actionTypes.TOGGLE_DELETE_MODAL:
      state.deleteModalOpen = !state.deleteModalOpen;

      return state;
    default:
      return state;
  }
});
